import { GPT_KEYS } from '@/lib/ads/constants/gpt'
import { type GptTargeting } from '@/lib/ads/types/adConfig'

export const getIntowowTargetingKeys = (): GptTargeting[] => {
  /**
   * Intowow benchmark/optimization traffic randomization keys
   */
  const optRatio = 0.9
  const trafficGroup = Math.random() < optRatio ? 'true' : 'false'

  const intowowKeys = [{ key: GPT_KEYS.INTOWOW, value: trafficGroup }]

  return intowowKeys
}
